<mat-card *ngIf="user | async as usr">
  <mat-card-header>
    <span class="rex-logo" mat-card-avatar
      ><img src="/assets/media/logos/rex-logo-medium.png" alt="ReX"
    /></span>
    <mat-card-title>Καλωσήρθατε ...</mat-card-title>
    <mat-card-subtitle>στον νέο τρόπο των ταχυμεταφορών</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <mat-divider></mat-divider>
    <div
      [ngClass]="{ fadmin: usr.is_staff, exp: expanded }"
      class="ac"
      [innerHTML]="(im | async)?.value"
    ></div>
    <ng-container *ngIf="usr.is_staff">
      <div *ngIf="!expanded" (click)="toggleExpanded()" class="arrow-down">
        <i class="fas fa-arrow-circle-down"></i>
      </div>
      <div *ngIf="expanded" (click)="toggleExpanded()" class="arrow-down">
        <i class="fas fa-arrow-circle-up"></i>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
